import { render, staticRenderFns } from "./TourBookingForm.vue?vue&type=template&id=2ea27e10"
import script from "./TourBookingForm.vue?vue&type=script&lang=js"
export * from "./TourBookingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports